<template>
    <section class="section bg-secondary" id="contact">
        <div class="container">
            <h2 class="section-title" v-scroll-reveal>
                <span class="_order">06</span>
                <span class="_title" v-html="$t('Contact')"></span>
            </h2>

            <div class="flex flex-wrap md:items-center">
                <div class="w-full md:w-1/2 mb-lg md:mb-0">
                    <h3 class="section-subtitle text-white" v-scroll-reveal v-html="$t('index.contact.title')"></h3>
                </div>

                <div class="w-full md:w-1/2 xl:w-2/5 xl:ml-auto">
                    <div class="flex flex-col">
                        <a href="tel:+385914392002" class="text-white hover:text-primary trans-color xl:text-h2" v-scroll-reveal>+ 385 91 4392002</a>
                        <a href="mailto:info@villa-kanedolo.com" class="text-white hover:text-primary trans-color xl:text-h2" v-scroll-reveal>info@villa-kanedolo.com</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {}
</script>
